<div class="grid grid-liquid travel-policy">
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-claim-small" class="xsmall"></open-svg-icon>
      <h2>Your trip</h2>
    </div>
    <div class="grid grid-large-12">
      <div class="cell cell-large-col-span-6 flex flex-column stat-block" *ngIf="policyDetails.coverType !== 'multi'">
        <span class="stat-block-title">Departure date</span>
        <span class="stat-block-value">{{ policyDetails.departureDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-6 flex flex-column stat-block" *ngIf="policyDetails.coverType === 'multi'">
        <span class="stat-block-title">Start date</span>
        <span class="stat-block-value">{{ policyDetails.startDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-6 flex flex-column stat-block">
        <span class="stat-block-title">End date</span>
        <span class="stat-block-value">{{ policyDetails.returnDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-6 flex flex-column stat-block">
        <span class="stat-block-title">Issue date</span>
        <span class="stat-block-value">{{ policyDetails.purchaseDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-6 flex flex-column stat-block">
        <span class="stat-block-title">Excess</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.excess" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.activityPacks?.length">
        <span class="stat-block-title">Optional Extras</span>
        <ul>
          <li *ngFor="let activity of policyDetails.activityPacks"><span class="stat-block-value">{{ activity | titlecase }} pack</span></li>
        </ul>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.valuables?.length">
        <span class="stat-block-title">Valuables Pack</span>
        <ul>
          <li *ngFor="let valuable of policyDetails.valuables"><span class="stat-block-value">{{ valuable.human_valuable_item }}({{ valuable.human_valuable_value }})</span></li>
        </ul>
      </div>
      <div class="cell cell-large-col-span-12 flex flex-column stat-block">
        <span class="stat-block-title">Premium</span>
        <span class="stat-block-value">
          <open-price [price]="policyDetails.premium" size="inherit"></open-price>{{ getArrangementFeeMessage() }}
        </span>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-drivers-small" class="xsmall"></open-svg-icon>
      <h2>Travellers</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Main traveller</span>
        <div class="grid grid-large-8 margin-none">
          <div class="cell cell-large-col-span-8 flex flex-column">
            <span class="stat-block-value">{{ policyDetails.primaryTraveller.givenName + ' ' + policyDetails.primaryTraveller.lastName | titlecase }}, {{ policyDetails.primaryTravellerDob | displayDate }}</span>
            <a href="#" color="primary" *ngIf="showDeclarationLink" (click)="downloadDeclaration($event, '0000')" target="_blank">Download Medical Declaration</a>
          </div>
        </div>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngFor="let traveller of policyDetails.additionalTravellers; index as i">
        <span class="stat-block-title">Second traveller</span>
        <span class="stat-block-value">{{ traveller.additional_traveller_given_name + ' ' + traveller.additional_traveller_last_name | titlecase }}, {{ traveller.additional_traveller_dob | displayDate }}</span>
        <a href="#" color="primary" *ngIf="showDeclarationLink" (click)="downloadDeclaration($event, traveller.id)" target="_blank">Download Medical Declaration</a>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.dependants?.length">
        <span class="stat-block-title">Child traveller(s)</span>
        <ul>
          <li *ngFor="let dependant of policyDetails.dependants; index as i">
            <span class="stat-block-value">
            {{ (dependant.dependent_traveller_given_name ? dependant.dependent_traveller_given_name + ' ' + dependant.dependent_traveller_last_name : 'dependant ' + (i + 1) ) | titlecase }}, {{ dependant.dependent_traveller_dob | displayDate }}
            </span>
            <a href="#" color="primary" *ngIf="showDeclarationLink" (click)="downloadDeclaration($event, dependant.id)" target="_blank">Download Medical Declaration</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
